module.exports = __webpack_public_path__ + "fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font-awesome-4.7.0/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 1250
// module chunks = 319